export default "__VITE_ASSET__DnHkFpHG__"